var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopiar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_522",
    "data-name": "Grupo 522",
    transform: "translate(-1456 -1540)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "content_copy_FILL0_wght300_GRAD0_opsz40",
    d: "M155.317-842.014a1.749,1.749,0,0,1-1.283-.534,1.749,1.749,0,0,1-.534-1.283v-14.352a1.749,1.749,0,0,1,.534-1.283,1.749,1.749,0,0,1,1.283-.534h10.868a1.749,1.749,0,0,1,1.283.534,1.749,1.749,0,0,1,.534,1.283v14.352a1.749,1.749,0,0,1-.534,1.283,1.749,1.749,0,0,1-1.283.534Zm0-1.459h10.868a.341.341,0,0,0,.246-.112.342.342,0,0,0,.112-.246v-14.352a.341.341,0,0,0-.112-.246.341.341,0,0,0-.246-.112H155.317a.341.341,0,0,0-.246.112.341.341,0,0,0-.112.246v14.352a.342.342,0,0,0,.112.246A.341.341,0,0,0,155.317-843.473Zm-3.5,4.958a1.749,1.749,0,0,1-1.283-.534,1.749,1.749,0,0,1-.534-1.283v-15.082a.7.7,0,0,1,.21-.52.711.711,0,0,1,.523-.209.7.7,0,0,1,.519.209.711.711,0,0,1,.207.52v15.082a.342.342,0,0,0,.112.246.341.341,0,0,0,.246.112h11.6a.7.7,0,0,1,.52.211.711.711,0,0,1,.209.523.7.7,0,0,1-.209.519.71.71,0,0,1-.52.207Zm3.141-4.958v0Z",
    transform: "translate(1309.998 2402)",
    fill: "#01e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_341",
    "data-name": "Rect\\xE1ngulo 341",
    width: 26,
    height: 26,
    transform: "translate(1456 1540)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopiar);
export default __webpack_public_path__ + "static/media/copiar.5f21a93bd2b19c736d7e83e5cfeac408.svg";
export { ForwardRef as ReactComponent };